import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager';

class PaginaLink extends Component {
    constructor(props) {
        super(props);
        this.paginaAnterior= this.paginaAnterior.bind(this);
        this.paginaSiguiente= this.paginaSiguiente.bind(this);
    }


    paginaAnterior(paginaNumero, arrayFiltrosDefinitivo) {
        this.props.setearInputPagina("");
        this.props.irAPagina(parseInt(paginaNumero)-1,this.props.registrosActivos, arrayFiltrosDefinitivo);
    }

    paginaSiguiente(paginaNumero, arrayFiltrosDefinitivo) {
        this.props.setearInputPagina("");
        this.props.irAPagina(parseInt(paginaNumero)+1,this.props.registrosActivos, arrayFiltrosDefinitivo);
    }

    render() {

        let cantPaginas = this.props.cantidadPaginas;
        let pagActual = this.props.paginaActual;
        let arrayFiltrosDefinitivo = this.props.arrayFiltrosDefinitivo;

        let paginaAnteriorSiguiente = <div className="row">
            <div className="col-xs-2" style={{paddingLeft:"34px"}}>
                <a className="btn-link btn-link-atlas btn-link-labeled-primary" onClick={()=>this.paginaAnterior(this.props.paginaActual, arrayFiltrosDefinitivo)}>&#60; Página Anterior</a>
            </div>
            <div className="col-xs-3">
            </div>
            <div className="col-xs-2">
                <label className="atlas label-grey-dark-14">-{pagActual} de {cantPaginas}-</label>
            </div>
            <div className="col-xs-3">
            </div>
            <div className="col-xs-2" style={{marginLeft:"-7px"}}>
                <a className="btn-link btn-link-atlas btn-link-labeled-primary" onClick={()=>this.paginaSiguiente(this.props.paginaActual, arrayFiltrosDefinitivo)}>Página Siguiente &gt;</a>
            </div>
        </div>;

        if (pagActual == 1) {

            //es la primera página
            paginaAnteriorSiguiente = <div className="row">
                <div className="col-xs-5">
                </div>
                <div className="col-xs-2">
                    <label className="atlas label-grey-dark-14">-{pagActual} de {cantPaginas}-</label>
                </div>
                <div className="col-xs-3">
                </div>
                <div className="col-xs-2" style={{marginLeft:"-7px"}}>
                    <a className="btn-link btn-link-atlas btn-link-labeled-primary" onClick={()=>this.paginaSiguiente(this.props.paginaActual, arrayFiltrosDefinitivo)}>Página Siguiente &gt;</a>
                </div>
            </div>;
        } else {
            if (pagActual == cantPaginas) {

                //es la ultima Página
                paginaAnteriorSiguiente = <div className="row">
                    <div className="col-xs-5" style={{paddingLeft:"35px"}}>
                        <a className="btn-link btn-link-atlas btn-link-labeled-primary" onClick={()=>this.paginaAnterior(this.props.paginaActual, arrayFiltrosDefinitivo)}>&#60; Página Anterior</a>
                    </div>
                    <div className="col-xs-2">
                        <label className="atlas label-grey-dark-14">-{pagActual} de {cantPaginas}-</label>
                    </div>
                    <div className="col-xs-5">
                    </div>
                </div>;
            }
        }

        return (
            <div className="row">
                {paginaAnteriorSiguiente}
            </div>
        );
    }
};

export default PaginaLink